import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ShareReportTableCell from './ShareReportTableCell';

const useStyles = makeStyles((theme) => ({
  headRow: {
    background: '#f6f6f6',
  },
  rowBorderRadius: {
    '& > :first-child': {
      borderTopLeftRadius: 3,
      borderBottomLeftRadius: 3,
    },
    '& > :last-child': {
      borderTopRightRadius: 3,
      borderBottomRightRadius: 3,
    },
  },
  sortIcon: {
    fontSize: 24,
    marginBottom: 2,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  tableSortLabel: {
    marginTop: 2,
  },
  tableSortLabelActive: {
    color: '#908F90 !important',
  },
  checkbox: {
    padding: 5,
  },
  checkboxIcon: {
    width: 17,
    height: 17,
    borderRadius: 3,
    border: `2px solid ${grey[300]}`,
    backgroundColor: '#ffffff',
    margin: 2,
  },
}));

function ShareReportTableHead({ tableType, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort }) {
  const classes = useStyles();
  const headCells = [
    { id: 'email', 'data-email': true, label: 'Email Address' },
    { id: 'timesShared', 'data-times-shared': true, label: 'Times Shared' },
    { id: 'lastSent', 'data-last-sent': true, label: 'Last Sent' },
    { id: 'menu', 'data-menu': true, label: '' },
  ];

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow className={classnames(classes.headRow, classes.rowBorderRadius)}>
        {tableType === 'shared' && (
          <ShareReportTableCell padding="checkbox" variant="head">
            <Checkbox
              color="primary"
              icon={<span className={classes.checkboxIcon} />} 
              classes={{ root: classes.checkbox }}
              checked={rowCount > 0 && numSelected === rowCount}
              indeterminate={numSelected > 0 && numSelected < rowCount}
              onChange={onSelectAllClick}
            />
          </ShareReportTableCell>
        )}
        {headCells.map((headCell) => (
          <ShareReportTableCell
            key={headCell.id}
            variant="head"
            inherited={tableType === 'inherited'}
            sortDirection={orderBy === headCell.id ? order : false}
            {...headCell}
          >
            {headCell.label && (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                IconComponent={ArrowDropDownIcon}
                classes={{ 
                  root: classes.tableSortLabel, 
                  active: classes.tableSortLabelActive, 
                  icon: classes.sortIcon,
                }}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            )}
          </ShareReportTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

ShareReportTableHead.propTypes = {
  tableType: PropTypes.string.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default ShareReportTableHead;


// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/components/ShareReport/components/ShareReportTableHead.jsx